/*
 * @Description: 实时定位驾驶舱 — C1「事件流」本地 mock（时间倒序）
 *   覆盖拍照 / 停留超限 / 连续移动超距 / 离线 / 重新上线 / 低电休眠 6 类事件。
 */
import { EventsFeedData } from '../types/cockpit.types'

export const MOCK_EVENTS_FEED: EventsFeedData = {
  total: 9,
  items: [
    {
      time: 1780907000000,
      type: 'photo',
      userId: 'mock-u1',
      userName: '徐兴泽',
      avatar: '',
      desc: '拍照 10 张',
      address: '深圳市南山区科技园南区',
      location: '113.9412,22.5470',
      thumbnails: [
        'https://picsum.photos/seed/p1/80/80',
        'https://picsum.photos/seed/p2/80/80',
        'https://picsum.photos/seed/p3/80/80'
      ],
      photoCount: 10
    },
    {
      time: 1780906500000,
      type: 'stay_timeout',
      userId: 'mock-u6',
      userName: '孙七',
      avatar: '',
      desc: '停留超过 30 分钟',
      address: '深圳市南山区沙河西路',
      location: '113.9288,22.5510',
      level: 'warn'
    },
    {
      time: 1780906200000,
      type: 'continuous_distance',
      userId: 'mock-u5',
      userName: '赵六',
      avatar: '',
      desc: '连续移动超过 2000 米',
      address: '深圳市南山区滨海大道',
      location: '113.9602,22.5333',
      level: 'warn'
    },
    {
      time: 1780905800000,
      type: 'online',
      userId: 'mock-u7',
      userName: '周八',
      avatar: '',
      desc: '重新上线',
      address: '深圳市南山区沙河西路',
      location: '113.9295,22.5515',
      level: 'info'
    },
    {
      time: 1780905000000,
      type: 'offline',
      userId: 'mock-u8',
      userName: '吴九',
      avatar: '',
      desc: '离线',
      address: '深圳市福田区车公庙',
      location: '113.9710,22.5280',
      level: 'warn'
    },
    {
      time: 1780904600000,
      type: 'deep_sleep',
      userId: 'mock-u8',
      userName: '吴九',
      avatar: '',
      desc: '工卡低电进入休眠',
      address: '深圳市福田区车公庙',
      location: '113.9710,22.5280',
      level: 'warn'
    },
    {
      time: 1780904200000,
      type: 'photo',
      userId: 'mock-u3',
      userName: '李四',
      avatar: '',
      desc: '拍照 5 张',
      address: '深圳市南山区高新南一道',
      location: '113.9435,22.5485',
      thumbnails: [
        'https://picsum.photos/seed/p4/80/80',
        'https://picsum.photos/seed/p5/80/80'
      ],
      photoCount: 5
    },
    {
      time: 1780903600000,
      type: 'stay_timeout',
      userId: 'mock-u4',
      userName: '王五',
      avatar: '',
      desc: '停留超过 45 分钟',
      address: '深圳市南山区深南大道',
      location: '113.9521,22.5391',
      level: 'warn'
    },
    {
      time: 1780902800000,
      type: 'offline',
      userId: 'mock-u9',
      userName: '郑十',
      avatar: '',
      desc: '离线',
      address: '深圳市南山区西丽',
      location: '113.9180,22.5600',
      level: 'warn'
    }
  ]
}
